export default "__VITE_ASSET__DsV$ig11__"